import React from 'react';
import { useSelector } from 'react-redux';
import { FLOWS_ENUM } from '../../common/enums';
import { selectRenewalPermitData } from '../../store/slices/renew/renewSelectors';
import { updatePermitData } from '../../store/slices/renew/renewSlice';
import { ApplicationData } from 'src/types/flow';
import { useAppDispatch } from 'src/store/store';
import { ContactsPage } from 'src/components/pages/ContactsPage';

const RenewContacts = () => {
  const dispatch = useAppDispatch();
  const data = useSelector(selectRenewalPermitData) as ApplicationData;

  const updateApplicationData = (data: ApplicationData) => {
    dispatch(updatePermitData(data));
  };

  return (
    <ContactsPage
      data={data}
      flow={FLOWS_ENUM.RENEW_LICENSE}
      updateApplicationData={updateApplicationData}
    />
  );
};

export default RenewContacts;
